import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSave, FaTimes, FaSearch, FaEye } from 'react-icons/fa';
import './Vendor.css';

const fetchVendors = () => {
  // Mock data, replace with actual API call
  return [
    {
      ID: 1,
      VendorID: 'V001',
      VendorName: 'Tech Supplies Inc.',
      ContactPersonName: 'John Doe',
      PrimaryEmail: 'john@techsupplies.com',
      AdditionalEmail1: 'sales@techsupplies.com',
      AdditionalEmail2: '',
      AdditionalEmail3: '',
      AdditionalEmail4: '',
      AdditionalEmail5: '',
      PhoneNumber: '123-456-7890',
      StreetAddress: '123 Tech St',
      City: 'Silicon Valley',
      State: 'CA',
      Country: 'USA',
      PostalCode: '94000',
      PaymentMethod: 'Bank Transfer',
      PayoutDetails: 'Account: 1234567890',
      PreferredNotificationMethod: 'Email'
    },
  ];
};

const Vendor = () => {
  const [vendors, setVendors] = useState([]);
  const [editingVendor, setEditingVendor] = useState(null);
  const [newVendor, setNewVendor] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [viewingVendor, setViewingVendor] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);

  useEffect(() => {
    setVendors(fetchVendors());
  }, []);

  const handleEdit = (vendor) => {
    setEditingVendor(vendor);
  };

  const handleDelete = (ID) => {
    setVendors(vendors.filter(vendor => vendor.ID !== ID));
  };

  const handleSave = (ID, updatedVendor) => {
    setVendors(vendors.map(vendor =>
      vendor.ID === ID ? { ...vendor, ...updatedVendor } : vendor
    ));
    setEditingVendor(null);
  };

  const handleAdd = () => {
    const addedVendor = {
      ID: Date.now(),
      ...newVendor
    };
    setVendors([...vendors, addedVendor]);
    setNewVendor({});
    setShowAddForm(false);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredVendors = vendors.filter(vendor =>
    Object.values(vendor).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const renderVendorCard = (vendor) => (
    <div key={vendor.ID} className="vendor-card">
      <h3>{vendor.VendorName}</h3>
      <p><strong>Contact:</strong> {vendor.ContactPersonName}</p>
      <p><strong>Email:</strong> {vendor.PrimaryEmail}</p>
      <p><strong>Phone:</strong> {vendor.PhoneNumber}</p>
      <div className="vendor-actions">
        <button onClick={() => setViewingVendor(vendor)} className="vendor-view-btn"><FaEye /></button>
        <button onClick={() => handleEdit(vendor)} className="vendor-edit-btn"><FaEdit /></button>
        <button onClick={() => handleDelete(vendor.ID)} className="vendor-delete-btn"><FaTrash /></button>
      </div>
    </div>
  );

  const renderVendorForm = (vendor, isEditing = false) => {
    const fieldGroups = [
      {
        title: 'Basic Information',
        fields: ['VendorID', 'VendorName', 'ContactPersonName']
      },
      {
        title: 'Contact Information',
        fields: ['PrimaryEmail', 'AdditionalEmail1', 'AdditionalEmail2', 'AdditionalEmail3', 'AdditionalEmail4', 'AdditionalEmail5', 'PhoneNumber']
      },
      {
        title: 'Address',
        fields: ['StreetAddress', 'City', 'State', 'Country', 'PostalCode']
      },
      {
        title: 'Payment Information',
        fields: ['PaymentMethod', 'PayoutDetails', 'PreferredNotificationMethod']
      }
    ];

    return (
      <div className={`vendor-form ${isEditing ? 'vendor-edit-form' : ''}`}>
        <h3>{isEditing ? 'Edit Vendor' : 'Add New Vendor'}</h3>
        <div className="vendor-form-groups">
          {fieldGroups.map((group, index) => (
            <div key={index} className="vendor-form-group">
              <h4>{group.title}</h4>
              {group.fields.map(field => (
                field === 'PreferredNotificationMethod' ? (
                  <select
                    key={field}
                    className="vendor-input"
                    value={vendor[field] || ''}
                    onChange={(e) => isEditing 
                      ? setEditingVendor({...editingVendor, [field]: e.target.value})
                      : setNewVendor({...newVendor, [field]: e.target.value})
                    }
                  >
                    <option value="">Select Notification Method</option>
                    <option value="Email">Email</option>
                    <option value="SMS">SMS</option>
                  </select>
                ) : (
                  <input
                    key={field}
                    className="vendor-input"
                    value={vendor[field] || ''}
                    onChange={(e) => isEditing 
                      ? setEditingVendor({...editingVendor, [field]: e.target.value})
                      : setNewVendor({...newVendor, [field]: e.target.value})
                    }
                    placeholder={field}
                  />
                )
              ))}
            </div>
          ))}
        </div>
        <div className="vendor-form-actions">
          {isEditing ? (
            <>
              <button onClick={() => handleSave(vendor.ID, editingVendor)} className="vendor-save-btn"><FaSave /> Save</button>
              <button onClick={() => setEditingVendor(null)} className="vendor-cancel-btn"><FaTimes /> Cancel</button>
            </>
          ) : (
            <>
              <button onClick={handleAdd} className="vendor-add-btn"><FaPlus /> Add Vendor</button>
              <button onClick={() => setShowAddForm(false)} className="vendor-cancel-btn"><FaTimes /> Cancel</button>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div> 
      <div className="vendor-header">
        <h2>Vendors</h2>
        <button onClick={() => setShowAddForm(!showAddForm)} className="vendor-add-toggle-btn">
          {showAddForm ? <><FaTimes /> Cancel</> : <><FaPlus /> Add Vendor</>}
        </button>
      </div>  
    <div className="vendor-container">

    
      <div className="vendor-search-bar">
        <FaSearch />
        <input
          type="text"
          placeholder="Search vendors..."
          value={searchTerm}
          onChange={handleSearch}
        />
      </div>
      {showAddForm && (
        <div className="vendor-add-form">
          <h3>Add New Vendor</h3>
          {renderVendorForm(newVendor)}
        </div>
      )}
      <div className="vendor-grid">
        {filteredVendors.map(vendor => 
          editingVendor && editingVendor.ID === vendor.ID
            ? <div key={vendor.ID} className="vendor-edit-container">{renderVendorForm(editingVendor, true)}</div>
            : renderVendorCard(vendor)
        )}
      </div>
      {viewingVendor && (
        <div className="vendor-modal">
          <div className="vendor-modal-content">
            <h2>{viewingVendor.VendorName}</h2>
            {Object.entries(viewingVendor).map(([key, value]) => (
              <p key={key}><strong>{key}:</strong> {value}</p>
            ))}
            <button onClick={() => setViewingVendor(null)} className="vendor-close-btn"><FaTimes /> Close</button>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default Vendor;

